import OnDropZone from './OnDropZone';

export default OnDropZone;
